module.exports = __webpack_public_path__ + "img/sac-sandwich-papier.8b232d19.png";